import { runInAction } from 'mobx'

/**
 * Defers MobX state mutations to the next microtask to avoid
 * "Cannot update component while rendering" React errors.
 *
 * Use this when MobX observable mutations trigger component re-renders
 * during another component's render phase (e.g., in ViewModel constructors
 * or useMemo callbacks).
 */
export function deferredRunInAction(fn: () => void): void {
    queueMicrotask(() => {
        runInAction(fn)
    })
}
